import { render, staticRenderFns } from "./pmIndex.vue?vue&type=template&id=18e86266&scoped=true&"
import script from "./pmIndex.vue?vue&type=script&lang=js&"
export * from "./pmIndex.vue?vue&type=script&lang=js&"
import style0 from "./pmIndex.vue?vue&type=style&index=0&id=18e86266&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e86266",
  null
  
)

export default component.exports